module.exports = __webpack_public_path__ + "static/media/logo-capeb.907ed4d7.svg";